/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { commentControllerCreate } from '../fn/comment/comment-controller-create';
import { CommentControllerCreate$Params } from '../fn/comment/comment-controller-create';
import { commentControllerDelete } from '../fn/comment/comment-controller-delete';
import { CommentControllerDelete$Params } from '../fn/comment/comment-controller-delete';
import { commentControllerFindAll } from '../fn/comment/comment-controller-find-all';
import { CommentControllerFindAll$Params } from '../fn/comment/comment-controller-find-all';
import { commentControllerFindById } from '../fn/comment/comment-controller-find-by-id';
import { CommentControllerFindById$Params } from '../fn/comment/comment-controller-find-by-id';
import { commentControllerSearch } from '../fn/comment/comment-controller-search';
import { CommentControllerSearch$Params } from '../fn/comment/comment-controller-search';
import { commentControllerToggleShowHide } from '../fn/comment/comment-controller-toggle-show-hide';
import { CommentControllerToggleShowHide$Params } from '../fn/comment/comment-controller-toggle-show-hide';
import { commentControllerUpdate } from '../fn/comment/comment-controller-update';
import { CommentControllerUpdate$Params } from '../fn/comment/comment-controller-update';
import { CommentDto } from '../models/comment-dto';
import { PaginationDto } from '../models/pagination-dto';

@Injectable({ providedIn: 'root' })
export class CommentService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `commentControllerSearch()` */
  static readonly CommentControllerSearchPath = '/api/comment/search';

  /**
   * 댓글 검색 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `commentControllerSearch()` instead.
   *
   * This method doesn't expect any request body.
   */
  commentControllerSearch$Response(params: CommentControllerSearch$Params, context?: HttpContext): Observable<StrictHttpResponse<PaginationDto>> {
    return commentControllerSearch(this.http, this.rootUrl, params, context);
  }

  /**
   * 댓글 검색 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `commentControllerSearch$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  commentControllerSearch(params: CommentControllerSearch$Params, context?: HttpContext): Observable<PaginationDto> {
    return this.commentControllerSearch$Response(params, context).pipe(
      map((r: StrictHttpResponse<PaginationDto>): PaginationDto => r.body)
    );
  }

  /** Path part for operation `commentControllerFindAll()` */
  static readonly CommentControllerFindAllPath = '/api/comment/gallery/{galleryId}';

  /**
   * 특정 갤러리의 댓글 전체 조회.
   *
   * 특정 갤러리 ID에 해당하는 최상위 댓글과 대댓글을 포함한 전체 댓글을 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `commentControllerFindAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  commentControllerFindAll$Response(params: CommentControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CommentDto>>> {
    return commentControllerFindAll(this.http, this.rootUrl, params, context);
  }

  /**
   * 특정 갤러리의 댓글 전체 조회.
   *
   * 특정 갤러리 ID에 해당하는 최상위 댓글과 대댓글을 포함한 전체 댓글을 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `commentControllerFindAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  commentControllerFindAll(params: CommentControllerFindAll$Params, context?: HttpContext): Observable<Array<CommentDto>> {
    return this.commentControllerFindAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<CommentDto>>): Array<CommentDto> => r.body)
    );
  }

  /** Path part for operation `commentControllerFindById()` */
  static readonly CommentControllerFindByIdPath = '/api/comment/{id}';

  /**
   * 댓글 ID로 조회.
   *
   * 특정 ID의 댓글을 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `commentControllerFindById()` instead.
   *
   * This method doesn't expect any request body.
   */
  commentControllerFindById$Response(params: CommentControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<CommentDto>> {
    return commentControllerFindById(this.http, this.rootUrl, params, context);
  }

  /**
   * 댓글 ID로 조회.
   *
   * 특정 ID의 댓글을 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `commentControllerFindById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  commentControllerFindById(params: CommentControllerFindById$Params, context?: HttpContext): Observable<CommentDto> {
    return this.commentControllerFindById$Response(params, context).pipe(
      map((r: StrictHttpResponse<CommentDto>): CommentDto => r.body)
    );
  }

  /** Path part for operation `commentControllerDelete()` */
  static readonly CommentControllerDeletePath = '/api/comment/{id}';

  /**
   * 댓글 삭제.
   *
   * 특정 ID의 댓글을 삭제합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `commentControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  commentControllerDelete$Response(params: CommentControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<CommentDto>> {
    return commentControllerDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * 댓글 삭제.
   *
   * 특정 ID의 댓글을 삭제합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `commentControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  commentControllerDelete(params: CommentControllerDelete$Params, context?: HttpContext): Observable<CommentDto> {
    return this.commentControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<CommentDto>): CommentDto => r.body)
    );
  }

  /** Path part for operation `commentControllerUpdate()` */
  static readonly CommentControllerUpdatePath = '/api/comment/{id}';

  /**
   * 댓글 수정.
   *
   * 기존 댓글을 수정합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `commentControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  commentControllerUpdate$Response(params: CommentControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<CommentDto>> {
    return commentControllerUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * 댓글 수정.
   *
   * 기존 댓글을 수정합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `commentControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  commentControllerUpdate(params: CommentControllerUpdate$Params, context?: HttpContext): Observable<CommentDto> {
    return this.commentControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<CommentDto>): CommentDto => r.body)
    );
  }

  /** Path part for operation `commentControllerCreate()` */
  static readonly CommentControllerCreatePath = '/api/comment';

  /**
   * 댓글 생성.
   *
   * 새로운 댓글을 생성합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `commentControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  commentControllerCreate$Response(params: CommentControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<CommentDto>> {
    return commentControllerCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * 댓글 생성.
   *
   * 새로운 댓글을 생성합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `commentControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  commentControllerCreate(params: CommentControllerCreate$Params, context?: HttpContext): Observable<CommentDto> {
    return this.commentControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<CommentDto>): CommentDto => r.body)
    );
  }

  /** Path part for operation `commentControllerToggleShowHide()` */
  static readonly CommentControllerToggleShowHidePath = '/api/comment/toggle-show-hide/{id}';

  /**
   * 댓글 숨김/표시.
   *
   * 댓글을 숨김 및 표시합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `commentControllerToggleShowHide()` instead.
   *
   * This method doesn't expect any request body.
   */
  commentControllerToggleShowHide$Response(params: CommentControllerToggleShowHide$Params, context?: HttpContext): Observable<StrictHttpResponse<CommentDto>> {
    return commentControllerToggleShowHide(this.http, this.rootUrl, params, context);
  }

  /**
   * 댓글 숨김/표시.
   *
   * 댓글을 숨김 및 표시합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `commentControllerToggleShowHide$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  commentControllerToggleShowHide(params: CommentControllerToggleShowHide$Params, context?: HttpContext): Observable<CommentDto> {
    return this.commentControllerToggleShowHide$Response(params, context).pipe(
      map((r: StrictHttpResponse<CommentDto>): CommentDto => r.body)
    );
  }

}
